import { useEffect, useRef } from 'react'
import i18next from 'i18next'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faGhost,
  faHeart,
  faSeedling,
  faTree,
} from '@fortawesome/free-solid-svg-icons'
import { Store } from './toast'
import { haptic, sushiRain } from './fx'

export function seasonalIcon(date = new Date()): IconDefinition | null {
  const month = date.getMonth() + 1
  const day = date.getDate()

  if ((month === 12 && day >= 1) || (month === 1 && day <= 7)) return faTree
  if ((month === 10 && day >= 24) || (month === 11 && day === 1)) return faGhost
  if (month === 3 && day <= 8) return faSeedling
  if (month === 2 && day >= 10 && day <= 14) return faHeart
  return null
}

export function celebrate() {
  haptic([15, 40, 15, 40, 30])
  sushiRain()
  Store.addNotification({
    message: i18next.t('SUSHI_RAIN'),
    type: 'info',
    dismiss: { duration: 2200 },
  })
}

const KONAMI = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
]

export function useKonamiCode(onUnlock: () => void) {
  useEffect(() => {
    let position = 0
    const onKey = (e: KeyboardEvent) => {
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key
      position = key === KONAMI[position] ? position + 1 : key === KONAMI[0] ? 1 : 0
      if (position === KONAMI.length) {
        position = 0
        onUnlock()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onUnlock])
}

export function useTapCounter(target: number, onUnlock: () => void) {
  const taps = useRef<number[]>([])

  return () => {
    const now = Date.now()
    taps.current = [...taps.current.filter((t) => now - t < 2500), now]
    if (taps.current.length >= target) {
      taps.current = []
      onUnlock()
      return true
    }
    return false
  }
}
